export type SideBias = 'bullish' | 'bearish' | 'sideways';
export type PivotPoint = { label: string; atUtc: string };

export function sideBias(points: PivotPoint[], bullishLabel: string, bearishLabel: string): SideBias {
  const latest = points.slice(-2).map(p => p.label);
  if (latest.length < 2) return 'sideways';
  if (latest.every(label => label === bullishLabel)) return 'bullish';
  if (latest.every(label => label === bearishLabel)) return 'bearish';
  return 'sideways';
}

export function timeframeBias(highs: PivotPoint[], lows: PivotPoint[]): SideBias {
  const top = sideBias(highs, 'HH', 'LH');
  const bottom = sideBias(lows, 'HL', 'LL');
  return top === bottom ? top : 'sideways';
}
